import styled from "styled-components";
import Link from "gatsby-link";
import { getThemeColor } from "../../utils";

export const InternalButton = styled(Link)`outline: none;
  border: none;
  border: 2px solid ${getThemeColor("teal")};
  border-radius: 4px;
  background: none;
  color: ${getThemeColor("teal")};
  padding: .5rem 1rem;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  &:active {
    transform: translateY(2px);
  }`;

export default styled.a`
  outline: none;
  border: none;
  border: 2px solid ${getThemeColor("teal")};
  border-radius: 4px;
  background: none;
  color: ${getThemeColor("teal")};
  padding: .5rem 1rem;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  &:active {
    transform: translateY(2px);
  }
`;



// WEBPACK FOOTER //
// ./src/components/atoms/Button.js